module.exports = __webpack_public_path__ + "static/media/light-theme-dpf.0f746822.svg";